module.exports = __webpack_public_path__ + "img/starkware.5344190c.svg";